// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingLimits__container--39y","title":"PendingLimits__title--2ed","error":"PendingLimits__error--3Mr","limits":"PendingLimits__limits--3s1"};